export default "__VITE_ASSET__B3q5De2j__"